import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

interface PortalDsFieldProps {
  label: string;
  htmlFor?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  filter?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function PortalDsField({
  label,
  htmlFor,
  hint,
  error,
  required = false,
  filter = false,
  children,
  className,
}: PortalDsFieldProps) {
  return (
    <div className={cn(portalDs.field, className)}>
      <label
        htmlFor={htmlFor}
        className={filter ? portalDs.filterLabel : portalDs.label}
      >
        {label}
        {required ? (
          <span className="ml-0.5 text-[#DC2626]">
            *
          </span>
        ) : null}
      </label>
      {children}
      {error ? (
        <p
          className="text-xs text-[#DC2626]"
          role="alert"
        >
          {error}
        </p>
      ) : null}
      {!error && hint ? (
        <p className={portalDs.hint}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}

export interface PortalDsInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export function PortalDsInput({ className, type, ...props }: PortalDsInputProps) {
  return (
    <input
      type={type}
      className={cn(portalDs.input, type === 'date' && 'relative', className)}
      {...props}
    />
  );
}

export interface PortalDsSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

export function PortalDsSelect({ className, children, ...props }: PortalDsSelectProps) {
  return (
    <select
      className={cn(portalDs.select, className)}
      {...props}
    >
      {children}
    </select>
  );
}
